export default __webpack_public_path__ + "static/media/template.8b43d9ed.png";